// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconDarkModePath = 'M9 2H7V0h2v2Zm5.707.707-1.414-1.414-1.5 1.5 1.414 1.414 1.5-1.5ZM2.793 11.793l-1.5 1.5 1.414 1.414 1.5-1.5-1.414-1.414ZM2 9H0V7h2v2Zm2.207-6.207-1.5-1.5-1.414 1.414 1.5 1.5 1.414-1.414ZM13 8c0-2.757-2.243-5-5-5S3 5.243 3 8s2.243 5 5 5 5-2.243 5-5Zm2.007-3.253a1.02 1.02 0 0 1 1.11-.073c2.985 1.902 4.418 5.346 3.692 8.8a8.194 8.194 0 0 1-6.336 6.334 8.658 8.658 0 0 1-1.778.187A8.248 8.248 0 0 1 4.7 16.16a1.016 1.016 0 0 1 .047-1.153 1.007 1.007 0 0 1 1.048-.369 7.102 7.102 0 0 0 4.18.083 6.901 6.901 0 0 0 4.747-4.75c.388-1.38.365-2.8-.064-4.103a1.012 1.012 0 0 1 .348-1.12Zm2.845 8.314v.001a6.197 6.197 0 0 1-4.79 4.79c-1.712.358-3.42.024-4.79-.858a9.371 9.371 0 0 0 2.247-.348 8.919 8.919 0 0 0 6.13-6.136 9.433 9.433 0 0 0 .347-2.226c.884 1.373 1.214 3.073.856 4.777ZM8 5C6.346 5 5 6.346 5 8s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3Z';
var IconDarkMode = baseIcon('IconDarkMode', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconDarkModePath
});
export default IconDarkMode;
//# sourceMappingURL=index.js.map